import { isInSilentLoginIframe } from '../init'
import type { SparkySettings } from '../framework/microAppTypes'

const render = (settings: SparkySettings) => {
  const promise = isInSilentLoginIframe ?
    import(/* webpackPreload: true */ './silent') :
    import(/* webpackPreload: true */ './app')
  return promise.then(({ default: render }) => {
    render(settings)
  })
}

export default render
